import { useWorkerProfileContext } from 'pages/WorkerProfilePage/components'
import { useCompanyInfo } from 'queries/company'
import { Avatar, Box, Flex, Heading, Pluralize, Text } from 'ui'

interface Props {
  workerId: number
  upcoming: number
  completed: number
}

export function Header(props: Props) {
  const { upcoming, completed } = props
  const { state: profile } = useWorkerProfileContext()
  const { data: companyInfo } = useCompanyInfo()

  if (!profile) {
    return null
  }

  return (
    <Flex flexDirection={'row'} mt={2} mb={4}>
      <Avatar
        size={'xlarge'}
        user={{
          userId: profile.worker.id.toString(),
          name: profile.worker.name,
          photoUrl: profile.worker.profilePicUrl,
        }}
      />
      <Box pl={3}>
        <Heading level={2} my={0} mb={1}>
          {profile.worker.name}
        </Heading>
        <Box display={'inline-flex'}>
          <Text fontWeight={2}>{companyInfo?.name}</Text>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Text color={'lightText'}>
            <Pluralize
              count={completed}
              oneText={'Completed Shift'}
              manyText={'Completed Shifts'}
            />
            &nbsp;&nbsp;•&nbsp;&nbsp;
            <Pluralize
              count={upcoming}
              oneText={'Upcoming Shift'}
              manyText={'Upcoming Shifts'}
            />
          </Text>
        </Box>
      </Box>
    </Flex>
  )
}
